module.exports = __webpack_public_path__ + "img/NEW YEAR.116c988.svg";